import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import Reducer from './reducers/reducer';
import { composeWithDevTools } from 'redux-devtools-extension';
const rootReducer = combineReducers({
    Reducer,
});
export default createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
